import { Pipe, PipeTransform } from '@angular/core';

import { DprCardFilters } from '@dpr/models';

@Pipe({
  name: 'selectedStatusFilterNames',
})
export class SelectedStatusFilterNamesPipe implements PipeTransform {
  transform(
    filters: Partial<DprCardFilters>,
    statusFilterNames: { [key: string]: string }
  ): string[] {
    const selected = [];

    if (filters.isCompleted) {
      selected.push(statusFilterNames.isCompleted);
    }

    if (filters.isIncompleted) {
      selected.push(statusFilterNames.isIncompleted);
    }

    if (filters.isLocked) {
      selected.push(statusFilterNames.isLocked);
    }

    if (filters.isUnlocked) {
      selected.push(statusFilterNames.isUnlocked);
    }

    if (filters.isSignedDprDetailsUploaded) {
      selected.push(statusFilterNames.isSignedDprDetailsUploaded);
    }

    if (filters.isSignedDprDetailsNotUploaded) {
      selected.push(statusFilterNames.isSignedDprDetailsNotUploaded);
    }

    return selected;
  }
}
